import { withStyles } from '@material-ui/core';
import reportConstants from '../constants';
import EnterTerminalIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/EnterTerminalIcon';
import LeaveTerminalIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/LogoutIcon';
const styles = () => ({
  terminalGeofenceEntryExitIcon: {
    cursor: 'pointer',
    marginTop: '2px'
  }
});

const TerminalGeofenceEntryExitIcon = ({ classes, type, theme }) => {
  return type === reportConstants.REPORT_STOP_TYPES.terminalEntryStop ? (
    <div className={classes.terminalGeofenceEntryExitIcon}>
      <EnterTerminalIcon
        color={theme.iconColor}
        height="32"
        width="32"
        viewBox="0 0 24 24"
      />
    </div>
  ) : (
    <div className={classes.terminalGeofenceEntryExitIcon}>
      <LeaveTerminalIcon
        color={theme.iconColor}
        height="20"
        width="20"
      />
    </div>
  );
};

export default withStyles(styles)(TerminalGeofenceEntryExitIcon);
